import { publicEnv } from "./publicEnv";

type Environment = "dev" | "prod" | "staging" | "testing";

export const currentEnv: Environment = publicEnv.NEXT_PUBLIC_ENVIRONMENT_TYPE;
